import React, { useState } from "react";
import { parsePromptMarkdown } from "../utils/promptMarkdownParser";
import "../styles/Modal.css";

const PromptMarkdownImportModal = ({ onImport, onCancel }) => {
  const [markdown, setMarkdown] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleImport = async () => {
    setError("");
    setLoading(true);

    try {
      console.log("🔄 Starting prompt markdown parse...");
      const prompts = parsePromptMarkdown(markdown);
      console.log("Parse successful. Prompts:", prompts);
      console.log("  - Count:", prompts?.length);

      if (!prompts || prompts.length === 0) {
        throw new Error("Parser returned no prompts");
      }

      onImport(prompts);
    } catch (err) {
      console.error("Parse error:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const exampleMarkdown = `**AI Content Strategy Prompt**
Category: Marketing
Prompt content: Create a content calendar for Q1 focusing on AI trends. Include 10 blog posts, 5 LinkedIn articles, and 3 case studies.

**Customer Support Automation**
Category: Operations
Prompt content: Design a chatbot flow for handling common customer support questions. Include escalation paths for complex issues.

**Data Analysis Template**
Category: Analytics
Prompt content: Analyze sales data for the past quarter. Identify top-performing regions, customer segments, and product categories.`;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>📝 Import Prompts from Markdown</h2>
          <button className="modal-close" onClick={onCancel}>✕</button>
        </div>

        <div className="modal-body" style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "600" }}>
              Markdown Format:
            </label>
            <textarea
              value={markdown}
              onChange={(e) => setMarkdown(e.target.value)}
              placeholder="Paste your prompts markdown here..."
              style={{
                width: "100%",
                height: "400px",
                padding: "12px",
                fontSize: "13px",
                fontFamily: "monospace",
                border: "1px solid #ddd",
                borderRadius: "6px",
                resize: "vertical"
              }}
            />
          </div>

          {error && (
            <div style={{
              padding: "12px",
              background: "#FFE5E5",
              color: "#C33",
              borderRadius: "6px",
              fontSize: "13px",
              whiteSpace: "pre-wrap",
              fontFamily: "monospace",
              maxHeight: "200px",
              overflowY: "auto"
            }}>
              {error}
            </div>
          )}

          <details style={{ fontSize: "12px", color: "#666" }}>
            <summary style={{ cursor: "pointer", marginBottom: "8px", fontWeight: "600" }}>
              View Example Format
            </summary>
            <pre style={{
              background: "#f5f5f5",
              padding: "12px",
              borderRadius: "4px",
              fontSize: "11px",
              overflowX: "auto",
              maxHeight: "300px",
              overflowY: "auto"
            }}>
              {exampleMarkdown}
            </pre>
          </details>
        </div>

        <div className="modal-footer">
          <button
            className="btn-cancel"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="btn-save"
            onClick={handleImport}
            disabled={loading || !markdown.trim()}
          >
            {loading ? "⏳ Parsing..." : "✓ Import"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromptMarkdownImportModal;
